import { environment } from '../../../environments/environment';
import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';

export const msalInstanceConfig: Configuration = {
  auth: {
    clientId: environment.msalConfig.auth.clientId,
    authority: environment.b2cCustomerPolicies.authorities.signInPolicyId.authority,
    redirectUri: `/`,
    postLogoutRedirectUri: `/`,
    knownAuthorities: [environment.b2cCustomerPolicies.authorityDomain]
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
}
